import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
    html: string;
    style?: React.CSSProperties;
    className?: string;
}

const useStyles = makeStyles({ name: 'HTML' })((theme) => ({
    container: {
        '& a': {
            color: theme.palette.primary.main
        }
    }
}));

const Html: React.ForwardRefRenderFunction<HTMLDivElement, Props> = ({ html, style, className }, ref) => {
    const { classes, cx } = useStyles();
    return (
        <div
            ref={ref}
            style={style}
            className={cx(classes.container, className)}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
};

export default React.forwardRef(Html);
